import { gql } from "@apollo/client";

export const FETCH_CORPORATE = gql`
  query FetchCorporate {
    findAllCorporates {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const EDIT_CORPORATE = gql`
  mutation UpdateCorporate($data: UpdateCorporatefinancialInput!) {
    updateCorporate(data: $data) {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const FETCH_CORPORATE_LOGO = gql`
  query FetchCorporateLogo {
    findAllBcpCorporates {
      corporateLogo
      uuid
    }
  }
`;
